import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container-wide flex-shrink-1 flex-grow-1 d-flex flex-column",
  style: {"min-height":"0"}
}
const _hoisted_2 = { class: "card d-flex flex-row flex-wrap justify-content-between align-items-center w-100 font-weight-bold p-5 mb-5" }
const _hoisted_3 = { class: "d-flex flex-row flex-wrap flex-grow-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "flex-shrink-0 d-flex flex-row align-items-center w-100 separator-bottom font-weight-bold p-4"
}
const _hoisted_6 = {
  class: "flex-shrink-1 flex-grow-1",
  style: {"min-height":"0"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  style: {"min-width":"240px"},
  class: "flex-grow-1 d-flex flex-wrap"
}
const _hoisted_9 = { class: "m-0" }
const _hoisted_10 = {
  key: 0,
  class: "flex-shrink-0",
  style: {"width":"180px"}
}
const _hoisted_11 = { class: "m-0" }
const _hoisted_12 = {
  key: 1,
  class: "flex-shrink-0",
  style: {"width":"180px"}
}
const _hoisted_13 = { class: "m-0" }
const _hoisted_14 = {
  style: {"width":"240px"},
  class: "flex-shrink-0 d-none d-lg-block"
}
const _hoisted_15 = { class: "m-0" }
const _hoisted_16 = {
  class: "flex-shrink-0",
  style: {"width":"180px"}
}
const _hoisted_17 = { class: "m-0" }
const _hoisted_18 = {
  class: "flex-shrink-0",
  style: {"width":"180px"}
}
const _hoisted_19 = { class: "m-0" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "mb-3 text-primary" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "d-flex flex-row" }
const _hoisted_24 = { class: "flex-shrink-0" }
const _hoisted_25 = {
  key: 0,
  class: "m-0 font-weight-bold"
}
const _hoisted_26 = { class: "m-0 font-weight-bold" }
const _hoisted_27 = { class: "m-0 font-weight-bold" }
const _hoisted_28 = { class: "m-0 font-weight-bold" }
const _hoisted_29 = { class: "m-0 font-weight-bold" }
const _hoisted_30 = { class: "flex-grow-1 px-4" }
const _hoisted_31 = {
  key: 0,
  class: "m-0"
}
const _hoisted_32 = { class: "m-0" }
const _hoisted_33 = { class: "m-0" }
const _hoisted_34 = { class: "m-0" }
const _hoisted_35 = { class: "m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectForm = _resolveComponent("ProjectForm")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_InfiniteList = _resolveComponent("InfiniteList")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_ctx.$route.params.id)
    ? (_openBlock(), _createBlock(_component_ProjectForm, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AnimatedInput, {
              modelValue: _ctx.searchTerm,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              modelModifiers: { lazy: true, trim: true },
              class: "flex-grow-1 mr-3",
              type: "text",
              label: _ctx.i18n.$gettext('Ausschreibung Suchen'),
              style: {"max-width":"400px"}
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.projectTypes,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.projectTypes) = $event)),
              class: "flex-grow-1",
              options: _ctx.TYPE_OPTIONS,
              "option-label": "label",
              "option-value": "type",
              label: _ctx.i18n.$gettext('Art der Ausschreibung'),
              style: {"max-width":"400px"}
            }, null, 8, ["modelValue", "options", "label"])
          ]),
          (_ctx.rpcClient.isInternalUser)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "ml-md-3 my-1 d-block",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/wizard/3')))
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode("  "),
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Ausschreibung erstellen")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["flex-shrink-1 flex-grow-1 card d-flex flex-column", { 'bg-light': _ctx.breakpointUtil.isOnMobile }]),
          style: {"min-height":"0"}
        }, [
          (!_ctx.breakpointUtil.isOnMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  key: "projects.name",
                  class: "table-column-name d-flex flex-row align-items-center flex-grow-1",
                  style: {"min-width":"240px"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSort('name')))
                }, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Titel")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", {
                    style: {"width":"15px"},
                    class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('name') ? '' : ' opacity-0'))
                  }, null, 2)
                ]),
                (_ctx.rpcClient.isInternalUser)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: "projects.created",
                      class: "table-column-name d-flex flex-row align-items-center .flex-shrink-0",
                      style: {"width":"180px"},
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSort('created')))
                    }, [
                      _createVNode(_component_translate, { style: {"word-break":"break-word"} }, {
                        default: _withCtx(() => [
                          _createTextVNode("Erstellt")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", {
                        style: {"width":"15px"},
                        class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('created') ? '' : ' opacity-0'))
                      }, null, 2)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: "projects.published",
                      class: "table-column-name d-flex flex-row align-items-center .flex-shrink-0",
                      style: {"width":"180px"},
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSort('published')))
                    }, [
                      _createVNode(_component_translate, { style: {"word-break":"break-word"} }, {
                        default: _withCtx(() => [
                          _createTextVNode("Veröffentlicht")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", {
                        style: {"width":"15px"},
                        class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('published') ? '' : ' opacity-0'))
                      }, null, 2)
                    ])),
                _createElementVNode("div", {
                  key: "projects.organization",
                  class: "table-column-name d-flex flex-row align-items-center flex-shrink-0 d-none d-lg-block",
                  style: {"width":"240px"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setSort('organization.name')))
                }, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Vergabestelle")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", {
                    style: {"width":"15px"},
                    class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('organization.name') ? '' : ' opacity-0'))
                  }, null, 2)
                ]),
                _createElementVNode("div", {
                  key: "projects.published",
                  class: "table-column-name d-flex flex-row align-items-center .flex-shrink-0",
                  style: {"width":"180px"},
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setSort('published')))
                }, [
                  _createVNode(_component_translate, { style: {"word-break":"break-word"} }, {
                    default: _withCtx(() => [
                      _createTextVNode("Phase")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", {
                    style: {"width":"15px"},
                    class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('published') ? '' : ' opacity-0'))
                  }, null, 2)
                ]),
                _createElementVNode("div", {
                  key: "projects.deadline",
                  class: "table-column-name d-flex flex-row align-items-center .flex-shrink-0",
                  style: {"width":"180px"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setSort('deadline')))
                }, [
                  _createVNode(_component_translate, { style: {"word-break":"break-word"} }, {
                    default: _withCtx(() => [
                      _createTextVNode("Abgabefrist")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", {
                    style: {"width":"15px"},
                    class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('deadline') ? '' : ' opacity-0'))
                  }, null, 2)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_InfiniteList, {
              class: "h-100",
              "get-all-items": _ctx.sort((_ctx.projects.data || []).filter(p => (_ctx.archived || !p.archived) && _ctx.matchesSearchTerm(p) && _ctx.matchesType(p))),
              "id-property": 'id',
              "auto-scroll-at-start": ""
            }, {
              element: _withCtx((props) => [
                (!_ctx.breakpointUtil.isOnMobile)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "d-flex flex-row align-items-center w-100 list-row px-4 clickable",
                      onClick: _withModifiers(($event: any) => (_ctx.goToProject(props.item.id)), ["stop","prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(props.item?.name), 1),
                        (_ctx.unreadMessages(props.item))
                          ? (_openBlock(), _createBlock(_component_Tag, {
                              key: 0,
                              class: "ml-3",
                              value: _ctx.unreadMessages(props.item) + ' ' + _ctx.i18n.$gettext('Nachrichten')
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.rpcClient.isInternalUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(props.item.created ? _ctx.dateTimeString(props.item.created) : ''), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(props.item.published ? _ctx.dateTimeString(props.item.published) : ''), 1)
                          ])),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(props.item?.organization?.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.stageName(props.item)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.getDeadline(props.item)), 1)
                      ])
                    ], 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "w-100 list-row card clickable z-1 p-3 mb-2",
                      onClick: ($event: any) => (_ctx.goToProject(props.item.id))
                    }, [
                      _createElementVNode("h5", _hoisted_21, _toDisplayString(props.item.name), 1),
                      _createElementVNode("div", {
                        class: "flex-grow-1",
                        innerHTML: _ctx.safeDescription(props.item)
                      }, null, 8, _hoisted_22),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          (_ctx.archived)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Archiviert:")
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_26, [
                            _createVNode(_component_translate, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Auftraggeber:")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("p", _hoisted_27, [
                            _createVNode(_component_translate, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Veröffentlicht:")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("p", _hoisted_28, [
                            _createVNode(_component_translate, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Frist:")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("p", _hoisted_29, [
                            _createVNode(_component_translate, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Stufe:")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          (_ctx.archived)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.dateString(props.item.archived)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_32, _toDisplayString(props.item.organization?.name || ''), 1),
                          _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.dateString(props.item.published)), 1),
                          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.dateString(props.item.finalDeadline)), 1),
                          _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.stageName(props.item)), 1)
                        ])
                      ])
                    ], 8, _hoisted_20))
              ]),
              _: 1
            }, 8, ["get-all-items"])
          ])
        ], 2),
        (_openBlock(), _createBlock(_Teleport, { to: "#breadcrumbs" }, [
          _createVNode(_component_Breadcrumb, {
            home: { icon: 'pi pi-home', to: '/' },
            model: _ctx.breadcrumbs
          }, null, 8, ["model"])
        ]))
      ]))
}